import React, { Component } from "react";
import EmailListDrawer from "../../../../common_components/activityComponent/emailnotify/emailList";
import FormsDetailsDrawer from "../../../../common_components/activityComponent/formslist/components/formsDetail";
import NoteListDrawer from "../../../../common_components/activityComponent/notelist/components/noteList";
import ActivityListDrawer from "../../../../common_components/activityComponent/tasklist/activityList";
import TimelineListDrawer from "../../../../common_components/activityComponent/timelineList";
import CallsListDrawer from "../../../../common_components/activityComponent/callslist/components/callList";
import CommunicationListDrawer from "../../../../common_components/activityComponent/loglist/components/logList";
import AttachmentListDrawer from "../../../../common_components/activityComponent/attachmentlist/components/attachmentList";
import { getProjectItem } from "../../../../utils/config";
import { get_Activity_Type } from "../../../apifunctions";
import "./navigation-menu.css";

let refresh = 1;
class RightSideNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editable: false,
      opentimeline: false,
      opennote: false,
      openemail: false,
      opentasks: false,
      openforms: false,
      opencalls: false,
      opencommunication: false,
      openattachment:false,
      typeData: [],
      openfilter: false,
      searchData: props.searchData ?? {},
      menuItems: getProjectItem("rightMenu") ?? []
    };
  }
  componentDidMount = () => {
    this.getTypes();
  };
  getTypes = () => {
    get_Activity_Type()
      .then((res) => res.data)
      .then((res) => {
        this.setState({ typeData: res?.data });
      });
  };
  componentWillReceiveProps = (props) => {
    this.setState({
      searchData: { ...this.state.searchData, ...props.searchData },
    });
  };
  handleManageEdit = () => {
    this.setState({ editable: true });
  };
  handleManageSave = () => {
    this.setState({ editable: false });
  };
  handleFilter = () => {
    this.setState({ openfilter: !this.state.openfilter }, () => {
      // refresh = refresh + 1;
    });
  };
  activictyColse = () => {
    this.setState({ openfilter: false });
  };
  handleTimeline = () => {
    this.setState({ opentimeline: true }, () => {
      refresh = refresh + 1;
    });
  };
  handleNote = () => {
    // e.preventDefault();
    this.setState(
      { opennote: true, searchData: { ...this.state.searchData } },
      () => {
        refresh = refresh + 1;
      }
    );
  };
  handleTasks = (item) => {
    this.setState(
      { opentasks: true, searchData: { ...this.state.searchData, ...item } },
      () => {
        refresh = refresh + 1;
      }
    );
  };
  handleEmail = () => {
    this.setState({ openemail: true }, () => {
      refresh = refresh + 1;
    });
  };
  filterEmailClose = () => {
    this.setState({ openemail: false });
  };
  handleForms = () => {
    this.setState({ openforms: true }, () => {
      refresh = refresh + 1;
    });
  };
  filterFormsClose = () => {
    this.setState({ openforms: false });
  };
  filterActClose = () => {
    this.setState({ opentasks: false });
  };
  filterTimeClose = () => {
    this.setState({ opentimeline: false });
  };
  filterNoteClose = () => {
    this.setState({ opennote: false });
  };
  handleCalls = () => {
    // e.preventDefault();
    this.setState(
      { opencalls: true, searchData: { ...this.state.searchData } },
      () => {
        refresh = refresh + 1;
      }
    );
  };
  filterCallsClose = () => {
    this.setState({ opencalls: false });
  };


  handleCommunicationLog = () => {
    // e.preventDefault();
    this.setState(
      { opencommunication: true, searchData: { ...this.state.searchData } },
      () => {
        refresh = refresh + 1;
      }
    );
  };
  filterCommunicationClose = () => {
    this.setState({ opencommunication: false });
  };

  handleAttachment = () => {
    // e.preventDefault();
    this.setState(
      { openattachment: true, searchData: { ...this.state.searchData } },
      () => {
        refresh = refresh + 1;
      }
    );
  };
  filterAttachmentClose = () => {
    this.setState({ openattachment: false });
  };

  render() {
    const { classes } = this.props;
    const { editable, menuItems } = this.state;

    return (
      <div className="inner-navmenu">
        <div className="navmenu-list">
          <ul>
            {
              menuItems.map((menu) => {
                console.log("Menu", menu);
                switch (menu["code"]) {
                  case "timeline":
                    return (
                      <li>
                        <a
                          href="#"
                          data-toggle="tooltip"
                          title="Timeline"
                          onClick={(e) => this.handleTimeline()}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.93155 3.67407V6.93558" stroke="#0077BE" />
                            <path d="M2.93155 9.45532V12.7168" stroke="#0077BE" />
                            <rect
                              x="5.84079"
                              y="0.754761"
                              width="6.18625"
                              height="3.42857"
                              rx="1"
                              stroke="#0077BE"
                              stroke-linejoin="round"
                            />
                            <rect
                              x="5.84079"
                              y="6.28577"
                              width="9.05797"
                              height="3.42857"
                              rx="1"
                              stroke="#0077BE"
                              stroke-linejoin="round"
                            />
                            <rect
                              x="5.84079"
                              y="11.8167"
                              width="7.23804"
                              height="3.42857"
                              rx="1"
                              stroke="#0077BE"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.14077 2.4691C4.14077 3.17036 3.57228 3.73885 2.87101 3.73885C2.16975 3.73885 1.60126 3.17036 1.60126 2.4691C1.60126 1.76783 2.16975 1.19934 2.87101 1.19934C3.57228 1.19934 4.14077 1.76783 4.14077 2.4691Z"
                              stroke="#0077BE"
                            />
                            <path
                              d="M4.14077 7.99998C4.14077 8.70125 3.57228 9.26974 2.87101 9.26974C2.16975 9.26974 1.60126 8.70125 1.60126 7.99998C1.60126 7.29871 2.16975 6.73022 2.87101 6.73022C3.57228 6.73022 4.14077 7.29871 4.14077 7.99998Z"
                              stroke="#0077BE"
                            />
                            <path
                              d="M4.14077 13.531C4.14077 14.2323 3.57228 14.8007 2.87101 14.8007C2.16975 14.8007 1.60126 14.2323 1.60126 13.531C1.60126 12.8297 2.16975 12.2612 2.87101 12.2612C3.57228 12.2612 4.14077 12.8297 4.14077 13.531Z"
                              stroke="#0077BE"
                            />
                          </svg>
                        </a>
                      </li>
                    )
                  case "notes":
                    return (
                      <li>
                        <a
                          href="#/"
                          data-toggle="tooltip"
                          title="Notes"
                          onClick={(e) => this.handleNote()}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="2.21426"
                              y="15.5"
                              width="15"
                              height="13.2857"
                              rx="1.5"
                              transform="rotate(-90 2.21426 15.5)"
                              stroke="#0077BE"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M0.822876 10.9286C0.546734 10.9286 0.322876 11.1524 0.322876 11.4286C0.322876 11.7047 0.546734 11.9286 0.822876 11.9286L0.822876 10.9286ZM3.55622 11.9286C3.83236 11.9286 4.05622 11.7047 4.05622 11.4286C4.05622 11.1524 3.83236 10.9286 3.55622 10.9286L3.55622 11.9286ZM0.822876 11.9286L3.55622 11.9286L3.55622 10.9286L0.822876 10.9286L0.822876 11.9286Z"
                              fill="#0077BE"
                            />
                            <path
                              d="M0.822876 7.5C0.546734 7.5 0.322876 7.72386 0.322876 8C0.322876 8.27614 0.546734 8.5 0.822876 8.5L0.822876 7.5ZM3.55622 8.5C3.83236 8.5 4.05622 8.27614 4.05622 8C4.05622 7.72386 3.83236 7.5 3.55622 7.5L3.55622 8.5ZM0.822876 8.5L3.55622 8.5L3.55622 7.5L0.822876 7.5L0.822876 8.5Z"
                              fill="#0077BE"
                            />
                            <path
                              d="M6.14545 6.27063C5.8693 6.27063 5.64545 6.49449 5.64545 6.77063C5.64545 7.04677 5.8693 7.27063 6.14545 7.27063L6.14545 6.27063ZM11.0689 7.27063C11.345 7.27063 11.5689 7.04677 11.5689 6.77063C11.5689 6.49449 11.345 6.27063 11.0689 6.27063L11.0689 7.27063ZM6.14545 7.27063L11.0689 7.27063L11.0689 6.27063L6.14545 6.27063L6.14545 7.27063Z"
                              fill="#0077BE"
                            />
                            <path
                              d="M6.14545 10.6689C5.8693 10.6689 5.64545 10.8928 5.64545 11.1689C5.64545 11.4451 5.8693 11.6689 6.14545 11.6689L6.14545 10.6689ZM9.28434 11.6689C9.56048 11.6689 9.78434 11.4451 9.78434 11.1689C9.78434 10.8928 9.56048 10.6689 9.28434 10.6689L9.28434 11.6689ZM6.14545 11.6689L9.28434 11.6689L9.28434 10.6689L6.14545 10.6689L6.14545 11.6689Z"
                              fill="#0077BE"
                            />
                            <path
                              d="M6.14545 4.07141C5.8693 4.07141 5.64545 4.29527 5.64545 4.57141C5.64545 4.84755 5.8693 5.07141 6.14545 5.07141L6.14545 4.07141ZM12.1806 5.07141C12.4568 5.07141 12.6806 4.84755 12.6806 4.57141C12.6806 4.29527 12.4568 4.07141 12.1806 4.07141L12.1806 5.07141ZM6.14545 5.07141L12.1806 5.07141L12.1806 4.07141L6.14545 4.07141L6.14545 5.07141Z"
                              fill="#0077BE"
                            />
                            <path
                              d="M6.14545 8.46985C5.8693 8.46985 5.64545 8.69371 5.64545 8.96985C5.64545 9.24599 5.8693 9.46985 6.14545 9.46985L6.14545 8.46985ZM12.1806 9.46985C12.4568 9.46985 12.6806 9.24599 12.6806 8.96985C12.6806 8.69371 12.4568 8.46985 12.1806 8.46985L12.1806 9.46985ZM6.14545 9.46985L12.1806 9.46985L12.1806 8.46985L6.14545 8.46985L6.14545 9.46985Z"
                              fill="#0077BE"
                            />
                            <path
                              d="M0.822876 4.07141C0.546734 4.07141 0.322876 4.29527 0.322876 4.57141C0.322876 4.84755 0.546734 5.07141 0.822876 5.07141L0.822876 4.07141ZM3.55622 5.07141C3.83236 5.07141 4.05622 4.84755 4.05622 4.57141C4.05622 4.29527 3.83236 4.07141 3.55622 4.07141L3.55622 5.07141ZM0.822876 5.07141L3.55622 5.07141L3.55622 4.07141L0.822876 4.07141L0.822876 5.07141Z"
                              fill="#0077BE"
                            />
                          </svg>
                        </a>
                      </li>
                    )
                  case "activity":
                    return (

                      this.state.typeData.map((item) => (
                        <li>
                          <a
                            href="#/"
                            data-toggle="tooltip"
                            title={item.display_name}
                            onClick={(e) => this.handleTasks(item)}
                          >
                            {item.display_name === "Meeting" ? (
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask id="path-1-inside-1_6934_109877" fill="white">
                                  <path d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V12.3423C16 13.4469 15.1046 14.3423 14 14.3423H10.314L8.59685 15.579C8.24771 15.8304 7.77686 15.8304 7.42779 15.5788L5.71195 14.3423H2C0.895428 14.3423 0 13.4469 0 12.3423V2Z" />
                                </mask>
                                <path
                                  d="M10.314 14.3423V13.3423C10.1042 13.3423 9.89976 13.4083 9.72955 13.5309L10.314 14.3423ZM5.71195 14.3423L6.2966 13.531C6.12634 13.4083 5.92181 13.3423 5.71195 13.3423V14.3423ZM8.59685 15.579L8.01244 14.7675L8.59685 15.579ZM7.42779 15.5788L6.84315 16.3901L7.42779 15.5788ZM2 1H14V-1H2V1ZM15 2V12.3423H17V2H15ZM1 12.3423V2H-1V12.3423H1ZM14 13.3423H10.314V15.3423H14V13.3423ZM9.72955 13.5309L8.01244 14.7675L9.18126 16.3904L10.8984 15.1538L9.72955 13.5309ZM8.01244 14.7675L6.2966 13.531L5.12731 15.1536L6.84315 16.3901L8.01244 14.7675ZM5.71195 13.3423H2V15.3423H5.71195V13.3423ZM8.01244 14.7675L8.01244 14.7675L6.84315 16.3901C7.54129 16.8932 8.48298 16.8933 9.18126 16.3904L8.01244 14.7675ZM-1 12.3423C-1 13.9992 0.343142 15.3423 2 15.3423V13.3423C1.44771 13.3423 1 12.8946 1 12.3423H-1ZM15 12.3423C15 12.8946 14.5523 13.3423 14 13.3423V15.3423C15.6569 15.3423 17 13.9992 17 12.3423H15ZM14 1C14.5523 1 15 1.44772 15 2H17C17 0.343146 15.6569 -1 14 -1V1ZM2 -1C0.343146 -1 -1 0.343146 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z"
                                  fill="#0077BE"
                                  mask="url(#path-1-inside-1_6934_109877)"
                                />
                                <ellipse
                                  cx="6.28487"
                                  cy="4.88686"
                                  rx="1.76952"
                                  ry="1.77357"
                                  stroke="#0077BE"
                                />
                                <ellipse
                                  cx="10.7822"
                                  cy="5.20097"
                                  rx="1.32746"
                                  ry="1.32524"
                                  stroke="#0077BE"
                                />
                                <path
                                  d="M5.29046 8.39811C5.52927 8.25946 5.61047 7.95347 5.47182 7.71466C5.33317 7.47584 5.02718 7.39464 4.78837 7.53329L5.29046 8.39811ZM3.45315 8.69145L3.28171 8.22176L3.28171 8.22176L3.45315 8.69145ZM2.89022 10.5656L2.39301 10.6184C2.4093 10.7718 2.49545 10.909 2.62649 10.9904L2.89022 10.5656ZM7.78133 7.53329C7.54252 7.39464 7.23653 7.47584 7.09788 7.71466C6.95924 7.95347 7.04044 8.25946 7.27925 8.39811L7.78133 7.53329ZM9.11656 8.69145L9.288 8.22176V8.22176L9.11656 8.69145ZM9.67949 10.5656L9.94322 10.9904C10.0742 10.909 10.1604 10.7718 10.1767 10.6184L9.67949 10.5656ZM4.78837 7.53329C4.53614 7.67973 3.84205 8.01724 3.28171 8.22176L3.62458 9.16114C4.23786 8.9373 4.98544 8.57519 5.29046 8.39811L4.78837 7.53329ZM3.28171 8.22176C2.6708 8.44475 2.46091 9.01222 2.39129 9.44524C2.32021 9.88742 2.36467 10.3515 2.39301 10.6184L3.38742 10.5128C3.35891 10.2443 3.33096 9.90041 3.37862 9.60396C3.42775 9.29835 3.52775 9.19649 3.62458 9.16114L3.28171 8.22176ZM2.62649 10.9904C3.14859 11.3145 4.54691 11.9023 6.28485 11.9023V10.9023C4.74757 10.9023 3.53025 10.3744 3.15395 10.1408L2.62649 10.9904ZM7.27925 8.39811C7.58426 8.57519 8.33184 8.9373 8.94512 9.16114L9.288 8.22176C8.72765 8.01724 8.03356 7.67973 7.78133 7.53329L7.27925 8.39811ZM8.94512 9.16114C9.04195 9.19649 9.14196 9.29835 9.19109 9.60396C9.23875 9.90041 9.2108 10.2443 9.18228 10.5128L10.1767 10.6184C10.205 10.3515 10.2495 9.88742 10.1784 9.44524C10.1088 9.01222 9.89891 8.44475 9.288 8.22176L8.94512 9.16114ZM9.41575 10.1408C9.03945 10.3744 7.82214 10.9023 6.28485 10.9023V11.9023C8.02279 11.9023 9.42111 11.3145 9.94322 10.9904L9.41575 10.1408Z"
                                  fill="#0077BE"
                                />
                                <path
                                  d="M12.6184 7.13861C12.378 7.00269 12.073 7.08738 11.9371 7.32776C11.8012 7.56814 11.8858 7.87319 12.1262 8.0091L12.6184 7.13861ZM13.3755 8.02083L13.5429 7.54971V7.54971L13.3755 8.02083ZM13.7315 9.17509L13.9902 9.60295C14.1235 9.52234 14.2116 9.38417 14.2285 9.22928L13.7315 9.17509ZM11.4434 9.58C11.1683 9.60381 10.9646 9.84614 10.9884 10.1213C11.0122 10.3964 11.2545 10.6001 11.5296 10.5763L11.4434 9.58ZM12.1262 8.0091C12.3286 8.12354 12.8109 8.3508 13.208 8.49195L13.5429 7.54971C13.1978 7.42704 12.7684 7.22342 12.6184 7.13861L12.1262 8.0091ZM13.208 8.49195C13.2093 8.49243 13.2063 8.49135 13.2023 8.48809C13.1989 8.48522 13.1995 8.48459 13.203 8.49021C13.2122 8.50461 13.2294 8.54213 13.2415 8.61539C13.2667 8.76808 13.2525 8.95517 13.2344 9.12089L14.2285 9.22928C14.2464 9.06522 14.278 8.75473 14.2281 8.45252C14.1791 8.15555 14.0223 7.72011 13.5429 7.54971L13.208 8.49195ZM13.4728 8.74722C13.3574 8.81699 13.0233 9.01433 12.6209 9.20169C12.2058 9.39491 11.7719 9.55156 11.4434 9.58L11.5296 10.5763C12.0408 10.532 12.6067 10.3113 13.0429 10.1083C13.4917 9.89934 13.8603 9.68151 13.9902 9.60295L13.4728 8.74722Z"
                                  fill="#0077BE"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="0.5"
                                  y="2.21423"
                                  width="15"
                                  height="13.2857"
                                  rx="1.5"
                                  stroke="#0077BE"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5.07144 0.822876C5.07144 0.546734 4.84758 0.322876 4.57144 0.322876C4.2953 0.322876 4.07144 0.546734 4.07144 0.822876H5.07144ZM4.07144 3.55622C4.07144 3.83236 4.2953 4.05622 4.57144 4.05622C4.84758 4.05622 5.07144 3.83236 5.07144 3.55622H4.07144ZM4.07144 0.822876V3.55622H5.07144V0.822876H4.07144Z"
                                  fill="#0077BE"
                                />
                                <path
                                  d="M4.41925 10.7182C4.23386 10.5135 3.91766 10.4979 3.713 10.6833C3.50834 10.8687 3.49272 11.1849 3.6781 11.3895L4.41925 10.7182ZM5.00198 12.1063L4.63141 12.442C4.7262 12.5466 4.8608 12.6063 5.00198 12.6063C5.14317 12.6063 5.27777 12.5466 5.37255 12.442L5.00198 12.1063ZM7.59694 9.98631C7.78232 9.78165 7.7667 9.46545 7.56204 9.28006C7.35738 9.09468 7.04118 9.1103 6.85579 9.31496L7.59694 9.98631ZM3.6781 11.3895L4.63141 12.442L5.37255 11.7706L4.41925 10.7182L3.6781 11.3895ZM5.37255 12.442L7.59694 9.98631L6.85579 9.31496L4.63141 11.7706L5.37255 12.442Z"
                                  fill="#0077BE"
                                />
                                <path
                                  d="M4.41922 7.22747C4.23383 7.02281 3.91763 7.00719 3.71297 7.19257C3.50831 7.37796 3.49269 7.69416 3.67807 7.89882L4.41922 7.22747ZM5.00195 8.61556L4.63138 8.95123C4.72616 9.05587 4.86077 9.11556 5.00195 9.11556C5.14314 9.11556 5.27774 9.05587 5.37252 8.95123L5.00195 8.61556ZM7.59691 6.49558C7.78229 6.29092 7.76667 5.97473 7.56201 5.78934C7.35735 5.60395 7.04115 5.61958 6.85576 5.82424L7.59691 6.49558ZM3.67807 7.89882L4.63138 8.95123L5.37252 8.27989L4.41922 7.22747L3.67807 7.89882ZM5.37252 8.95123L7.59691 6.49558L6.85576 5.82424L4.63138 8.27989L5.37252 8.95123Z"
                                  fill="#0077BE"
                                />
                                <path
                                  d="M9.14288 10.9487C8.86674 10.9487 8.64288 11.1726 8.64288 11.4487C8.64288 11.7249 8.86674 11.9487 9.14288 11.9487L9.14288 10.9487ZM12.5715 11.9487C12.8476 11.9487 13.0715 11.7249 13.0715 11.4487C13.0715 11.1726 12.8476 10.9487 12.5715 10.9487L12.5715 11.9487ZM9.14288 11.9487L12.5715 11.9487L12.5715 10.9487L9.14288 10.9487L9.14288 11.9487Z"
                                  fill="#0077BE"
                                />
                                <path
                                  d="M9.14288 7.52014C8.86674 7.52014 8.64288 7.744 8.64288 8.02014C8.64288 8.29628 8.86674 8.52014 9.14288 8.52014L9.14288 7.52014ZM12.5715 8.52014C12.8476 8.52014 13.0715 8.29628 13.0715 8.02014C13.0715 7.744 12.8476 7.52014 12.5715 7.52014L12.5715 8.52014ZM9.14288 8.52014L12.5715 8.52014L12.5715 7.52014L9.14288 7.52014L9.14288 8.52014Z"
                                  fill="#0077BE"
                                />
                                <path
                                  d="M11.9286 0.822876C11.9286 0.546734 11.7047 0.322876 11.4286 0.322876C11.1524 0.322876 10.9286 0.546734 10.9286 0.822876H11.9286ZM10.9286 3.55622C10.9286 3.83236 11.1524 4.05622 11.4286 4.05622C11.7047 4.05622 11.9286 3.83236 11.9286 3.55622H10.9286ZM10.9286 0.822876V3.55622H11.9286V0.822876H10.9286Z"
                                  fill="#0077BE"
                                />
                              </svg>
                            )}
                          </a>
                        </li>
                      ))

                    )
                  case "email":
                    return (
                      <li>
                        <a
                          href="#"
                          data-toggle="tooltip"
                          title="Email"
                          onClick={(e) => this.handleEmail()}
                        >
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_8395_25250)">
                              <path
                                d="M16.0586 3.25L8.50025 9.9157L0.941912 3.25"
                                stroke="#0077BE"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M1.71446 14.1404C1.50531 14.3207 1.18959 14.2973 1.00928 14.0882C0.828974 13.879 0.852357 13.5633 1.06151 13.383L1.71446 14.1404ZM5.69892 9.38516C5.90807 9.20485 6.22379 9.22824 6.40409 9.43739C6.5844 9.64654 6.56102 9.96226 6.35186 10.1426L5.69892 9.38516ZM1.06151 13.383L5.69892 9.38516L6.35186 10.1426L1.71446 14.1404L1.06151 13.383Z"
                                fill="#0077BE"
                              />
                              <path
                                d="M15.3793 14.1404C15.5884 14.3207 15.9042 14.2973 16.0845 14.0882C16.2648 13.879 16.2414 13.5633 16.0322 13.383L15.3793 14.1404ZM11.3948 9.38516C11.1857 9.20485 10.87 9.22824 10.6897 9.43739C10.5094 9.64654 10.5327 9.96226 10.7419 10.1426L11.3948 9.38516ZM16.0322 13.383L11.3948 9.38516L10.7419 10.1426L15.3793 14.1404L16.0322 13.383Z"
                                fill="#0077BE"
                              />
                              <mask id="path-4-inside-1_8395_25250" fill="white">
                                <rect
                                  x="0.5"
                                  y="2.26953"
                                  width="16"
                                  height="12.5"
                                  rx="0.936089"
                                />
                              </mask>
                              <rect
                                x="0.5"
                                y="2.26953"
                                width="16"
                                height="12.5"
                                rx="0.936089"
                                stroke="#0077BE"
                                stroke-width="2"
                                stroke-linejoin="round"
                                mask="url(#path-4-inside-1_8395_25250)"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_8395_25250">
                                <rect
                                  width="12.5"
                                  height="16"
                                  fill="white"
                                  transform="translate(0.5 14.7695) rotate(-90)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </li>
                    )
                  case "forms":
                    return (

                      this.state.searchData.external_form_data && (
                        <li>
                          <a
                            href="#"
                            data-toggle="tooltip"
                            title="Forms"
                            onClick={(e) => this.handleForms()}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.5"
                                y="0.5"
                                width="15"
                                height="15"
                                rx="1.5"
                                stroke="#0077BE"
                                stroke-linejoin="round"
                              />
                              <rect
                                x="2.8428"
                                y="4.21619"
                                width="10.2857"
                                height="2.85714"
                                stroke="#0077BE"
                                stroke-linejoin="round"
                              />
                              <rect
                                x="2.8428"
                                y="10.6792"
                                width="10.2857"
                                height="2.85714"
                                stroke="#0077BE"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M2.8428 2.09326C2.56666 2.09326 2.3428 2.31712 2.3428 2.59326C2.3428 2.8694 2.56666 3.09326 2.8428 3.09326L2.8428 2.09326ZM7.88879 3.09326C8.16493 3.09326 8.38879 2.8694 8.38879 2.59326C8.38879 2.31712 8.16493 2.09326 7.88879 2.09326L7.88879 3.09326ZM2.8428 3.09326L7.88879 3.09326L7.88879 2.09326L2.8428 2.09326L2.8428 3.09326Z"
                                fill="#0077BE"
                              />
                              <path
                                d="M2.8428 8.55615C2.56666 8.55615 2.3428 8.78001 2.3428 9.05615C2.3428 9.33229 2.56666 9.55615 2.8428 9.55615L2.8428 8.55615ZM7.88879 9.55615C8.16493 9.55615 8.38879 9.33229 8.38879 9.05615C8.38879 8.78001 8.16493 8.55615 7.88879 8.55615L7.88879 9.55615ZM2.8428 9.55615L7.88879 9.55615L7.88879 8.55615L2.8428 8.55615L2.8428 9.55615Z"
                                fill="#0077BE"
                              />
                            </svg>
                          </a>
                        </li>
                      )

                    )
                  case "calls":
                    return (
                      <li>
                        <a href="#" data-toggle="tooltip" title="Call" onClick={(e) => this.handleCalls()}>
                          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.66679 8.75576L1.20148 8.93876L1.66679 8.75576ZM15.0053 14.1492L15.4615 14.3538L15.0053 14.1492ZM5.12254 7.9723L4.66618 8.17661L5.12254 7.9723ZM5.21012 7.12966L5.62987 7.40133L5.21012 7.12966ZM15.7709 12.053L16.2583 12.1643L15.7709 12.053ZM15.3629 11.3477L15.1611 11.8052L15.3629 11.3477ZM9.15393 10.9175L9.39347 11.3564L9.15393 10.9175ZM8.37212 10.9709L8.17505 11.4304L8.37212 10.9709ZM4.9899 1.07038L4.53114 1.2692L4.9899 1.07038ZM11.0614 9.87632L11.301 10.3152L11.0614 9.87632ZM6.43809 4.41195L5.97933 4.61077L6.43809 4.41195ZM6.36006 5.35295L5.94031 5.08127L6.36006 5.35295ZM6.89686 4.21312L5.44867 0.871554L4.53114 1.2692L5.97933 4.61077L6.89686 4.21312ZM3.83845 0.0567453C2.73943 0.371392 1.48482 1.13529 0.811913 2.59899C0.138716 4.06332 0.0949566 6.12521 1.20148 8.93876L2.1321 8.57276C1.08566 5.91199 1.19939 4.1502 1.7205 3.01669C2.2419 1.88254 3.21841 1.27444 4.11369 1.01812L3.83845 0.0567453ZM1.20148 8.93876C2.78956 12.9768 6.04708 14.9365 9.01106 15.6105C10.4896 15.9468 11.9124 15.968 13.0432 15.7606C13.6081 15.657 14.1162 15.4934 14.5264 15.2712C14.9304 15.0522 15.2829 14.7521 15.4615 14.3538L14.5491 13.9445C14.4942 14.067 14.3493 14.2297 14.05 14.3919C13.7568 14.5508 13.3555 14.6866 12.8629 14.777C11.8786 14.9575 10.5933 14.9448 9.23281 14.6354C6.5187 14.0182 3.57423 12.2396 2.1321 8.57276L1.20148 8.93876ZM15.4615 14.3538C15.9208 13.3302 16.1537 12.6222 16.2583 12.1643L15.2834 11.9417C15.1984 12.3137 14.9924 12.9564 14.5491 13.9445L15.4615 14.3538ZM15.5648 10.8903L12.1461 9.38175L11.7424 10.2966L15.1611 11.8052L15.5648 10.8903ZM10.8219 9.43744L8.91438 10.4786L9.39347 11.3564L11.301 10.3152L10.8219 9.43744ZM8.5692 10.5113C7.62886 10.1081 6.21591 9.19093 5.5789 7.768L4.66618 8.17661C5.44969 9.92674 7.12638 10.9807 8.17505 11.4304L8.5692 10.5113ZM5.62987 7.40133L6.77981 5.62463L5.94031 5.08127L4.79037 6.85798L5.62987 7.40133ZM5.5789 7.768C5.53687 7.67412 5.54187 7.5373 5.62987 7.40133L4.79037 6.85798C4.55154 7.22698 4.46244 7.72149 4.66618 8.17661L5.5789 7.768ZM16.2583 12.1643C16.398 11.5527 16.0052 11.0846 15.5648 10.8903L15.1611 11.8052C15.2293 11.8353 15.2634 11.8721 15.2765 11.8934C15.2825 11.9033 15.2845 11.9102 15.2853 11.9146C15.286 11.9186 15.2868 11.9269 15.2834 11.9417L16.2583 12.1643ZM8.91438 10.4786C8.78666 10.5483 8.66118 10.5508 8.5692 10.5113L8.17505 11.4304C8.58945 11.6081 9.03754 11.5506 9.39347 11.3564L8.91438 10.4786ZM5.44867 0.871554C5.19637 0.289381 4.55002 -0.146975 3.83845 0.0567453L4.11369 1.01812C4.24439 0.980701 4.43506 1.04751 4.53114 1.2692L5.44867 0.871554ZM12.1461 9.38175C11.72 9.19373 11.2307 9.2143 10.8219 9.43744L11.301 10.3152C11.4373 10.2408 11.6004 10.234 11.7424 10.2966L12.1461 9.38175ZM5.97933 4.61077C6.04584 4.76426 6.0312 4.94084 5.94031 5.08127L6.77981 5.62463C7.05249 5.20333 7.09642 4.67358 6.89686 4.21312L5.97933 4.61077Z" fill="#0077BE" />
                            <path d="M9.83789 3.49609C10.6221 3.77833 12.2914 4.74921 12.6947 6.37483" stroke="#0077BE" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10.1787 0.960938C11.5603 1.45815 14.5011 3.16853 15.2116 6.03236" stroke="#0077BE" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </a>
                      </li>
                    )
                  case "communication_logs":
                    return (
                      <li>
                        <a href="#" data-toggle="tooltip" title="Log" onClick={(e) => this.handleCommunicationLog()}>
                          <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.11328 4.13089L0.777199 3.76069C0.672808 3.85546 0.613281 3.9899 0.613281 4.13089C0.613281 4.27189 0.672808 4.40633 0.777199 4.50109L1.11328 4.13089ZM4.58353 0.980469H5.08353C5.08353 0.782622 4.96687 0.603383 4.78597 0.523281C4.60506 0.443179 4.39394 0.477282 4.24745 0.610268L4.58353 0.980469ZM4.58353 7.28132L4.24745 7.65152C4.39394 7.7845 4.60506 7.81861 4.78597 7.73851C4.96687 7.6584 5.08353 7.47917 5.08353 7.28132H4.58353ZM4.58353 5.9258V5.4258C4.30739 5.4258 4.08353 5.64966 4.08353 5.9258H4.58353ZM9.82718 5.9258V6.4258C10.1033 6.4258 10.3272 6.20194 10.3272 5.9258H9.82718ZM9.82718 2.33578H10.3272C10.3272 2.05964 10.1033 1.83578 9.82718 1.83578V2.33578ZM4.58353 2.33578H4.08353C4.08353 2.61192 4.30739 2.83578 4.58353 2.83578V2.33578ZM1.44936 4.50109L4.91962 1.35067L4.24745 0.610268L0.777199 3.76069L1.44936 4.50109ZM4.91962 6.91112L1.44936 3.76069L0.777199 4.50109L4.24745 7.65152L4.91962 6.91112ZM4.08353 5.9258V7.28132H5.08353V5.9258H4.08353ZM9.82718 5.4258H4.58353V6.4258H9.82718V5.4258ZM9.32718 2.33578V5.9258H10.3272V2.33578H9.32718ZM4.58353 2.83578H9.82718V1.83578H4.58353V2.83578ZM4.08353 0.980469V2.33578H5.08353V0.980469H4.08353Z" fill="#0077BE"/>
                            <path d="M14.8877 10.5411L15.2238 10.1708C15.3282 10.2656 15.3877 10.4001 15.3877 10.5411C15.3877 10.682 15.3282 10.8165 15.2238 10.9113L14.8877 10.5411ZM11.4174 7.39062H10.9174C10.9174 7.19278 11.0341 7.01354 11.215 6.93344C11.3959 6.85334 11.607 6.88744 11.7535 7.02042L11.4174 7.39062ZM11.4174 13.6915L11.7535 14.0617C11.607 14.1947 11.3959 14.2288 11.215 14.1487C11.0341 14.0686 10.9174 13.8893 10.9174 13.6915H11.4174ZM11.4174 12.336V11.836C11.6936 11.836 11.9174 12.0598 11.9174 12.336H11.4174ZM6.1738 12.336V12.836C5.89765 12.836 5.6738 12.6121 5.6738 12.336H6.1738ZM6.1738 8.74593H5.6738C5.6738 8.46979 5.89765 8.24593 6.1738 8.24593V8.74593ZM11.4174 8.74593H11.9174C11.9174 9.02208 11.6936 9.24593 11.4174 9.24593V8.74593ZM14.5516 10.9113L11.0814 7.76083L11.7535 7.02042L15.2238 10.1708L14.5516 10.9113ZM11.0814 13.3213L14.5516 10.1708L15.2238 10.9113L11.7535 14.0617L11.0814 13.3213ZM11.9174 12.336V13.6915H10.9174V12.336H11.9174ZM6.1738 11.836H11.4174V12.836H6.1738V11.836ZM6.6738 8.74593V12.336H5.6738V8.74593H6.6738ZM11.4174 9.24593H6.1738V8.24593H11.4174V9.24593ZM11.9174 7.39062V8.74593H10.9174V7.39062H11.9174Z" fill="#0077BE"/>
                          </svg>
                        </a>
                      </li>
                    )
                  case "attachments":
                    return (
                      <li>
                        <a href="#" data-toggle="tooltip" title="Attachments" onClick={(e) => this.handleAttachment()}>
                          <svg width="19" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_8717_106383)">
                            <path d="M1.4668 1.33594V5.53594C1.4668 6.03101 1.66346 6.5058 2.01353 6.85587C2.3636 7.20594 2.83839 7.4026 3.33346 7.4026C3.82853 7.4026 4.30333 7.20594 4.6534 6.85587C5.00346 6.5058 5.20013 6.03101 5.20013 5.53594V2.73594C5.20013 2.4884 5.1018 2.25101 4.92676 2.07597C4.75173 1.90094 4.51433 1.8026 4.2668 1.8026C4.01926 1.8026 3.78186 1.90094 3.60683 2.07597C3.4318 2.25101 3.33346 2.4884 3.33346 2.73594V6.0026M6.60013 1.8026H12.6668C12.9143 1.8026 13.1517 1.90094 13.3268 2.07597C13.5018 2.25101 13.6001 2.4884 13.6001 2.73594V13.9359C13.6001 14.1835 13.5018 14.4209 13.3268 14.5959C13.1517 14.7709 12.9143 14.8693 12.6668 14.8693H3.33346C3.08593 14.8693 2.84853 14.7709 2.6735 14.5959C2.49846 14.4209 2.40013 14.1835 2.40013 13.9359V8.8026M11.2668 5.53594H7.53346M11.2668 8.33594H7.53346M11.2668 11.1359H4.73346" stroke="#0077BE"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_8717_106383">
                            <rect width="14" height="14" fill="white" transform="translate(1 1.33594)"/>
                            </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </li>
                    )
                  default:
                    return <></>
                }
              })
            }






            {/* <li>
              <a href="#" data-toggle="tooltip" title="Meeting">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.96747 0.990114C4.70368 1.055 4.46214 1.25254 4.33687 1.50585L4.26433 1.65252V3.45661V5.26069L4.33411 5.41528C4.42016 5.60593 4.66336 5.83574 4.85655 5.90899C4.97913 5.95545 5.11759 5.96346 5.95709 5.97259L6.91741 5.98303L7.35568 6.56667C7.59674 6.88768 7.81963 7.16407 7.85101 7.18088C7.95171 7.23486 8.10634 7.2167 8.19529 7.14046C8.24085 7.10144 8.48906 6.82564 8.74688 6.5276L9.21564 5.98567L10.1092 5.97379C10.8808 5.96352 11.0219 5.95466 11.143 5.90887C11.3361 5.8358 11.5794 5.60599 11.6655 5.41528L11.7352 5.26069V3.45661V1.65252L11.6351 1.46768C11.5239 1.26237 11.4327 1.17395 11.211 1.05688L11.0614 0.977823L8.05838 0.973159C6.40672 0.970577 5.01581 0.978204 4.96747 0.990114ZM1.21464 1.62046C0.933704 1.68872 0.672456 1.91645 0.570061 2.18228C0.517325 2.31915 0.514219 2.42696 0.514219 4.11664V5.90605L0.614329 6.09089C0.726305 6.2977 0.819208 6.38711 1.03844 6.49911C1.16082 6.56163 1.24139 6.57817 1.48104 6.58993L1.77402 6.60437L2.28486 7.19036C2.84093 7.82827 2.91484 7.88615 3.09658 7.8261C3.17691 7.79955 3.25121 7.72085 3.45091 7.45064C3.79536 6.98463 3.82055 6.93852 3.79773 6.81672C3.7721 6.67979 3.63346 6.56608 3.49221 6.56608C3.35036 6.56608 3.28745 6.61372 3.12101 6.84729C3.0083 7.0054 2.97631 7.0338 2.94704 7.00159C2.9273 6.97988 2.7296 6.75386 2.50769 6.49932C2.28579 6.24478 2.08024 6.02369 2.05091 6.00796C2.02159 5.99224 1.86358 5.97939 1.69981 5.97939C1.35084 5.97939 1.23108 5.93715 1.16102 5.78936C1.12071 5.70429 1.11482 5.48921 1.11482 4.10394C1.11482 2.39844 1.11664 2.37624 1.26474 2.27239C1.32307 2.23147 1.43191 2.22455 2.01587 2.22455C2.74899 2.22455 2.84837 2.20844 2.94209 2.07444C3.00338 1.98685 3.00338 1.81688 2.94209 1.72929C2.84822 1.59511 2.74884 1.57901 2.03131 1.58168C1.60978 1.58326 1.30886 1.59755 1.21464 1.62046ZM10.9448 1.62545C11.1372 1.71685 11.1346 1.69189 11.1346 3.45464C11.1346 5.16013 11.1328 5.18234 10.9847 5.28618C10.9252 5.32793 10.8003 5.33403 10.0045 5.33403C9.40663 5.33403 9.0601 5.34535 8.99837 5.36691C8.93295 5.38973 8.77357 5.54882 8.47666 5.8876C8.24152 6.1559 8.03893 6.37952 8.02648 6.3845C8.01402 6.38952 7.84656 6.18491 7.65434 5.92982C7.46211 5.67475 7.27528 5.43963 7.23913 5.40736C7.17667 5.3516 7.1208 5.34796 6.11149 5.33403C5.22597 5.32179 5.0408 5.31206 4.99668 5.27536C4.86809 5.16843 4.86493 5.12484 4.86493 3.45464C4.86493 2.07204 4.87088 1.85417 4.91096 1.76963C5.00544 1.57024 4.8373 1.58059 7.99536 1.57986C10.5329 1.57927 10.8582 1.58429 10.9448 1.62545ZM13.1966 1.62016C13.1463 1.64272 13.0836 1.69189 13.0574 1.72938C12.9962 1.81691 12.9962 1.98688 13.0575 2.07444C13.1512 2.20844 13.2506 2.22455 13.9837 2.22455C14.5677 2.22455 14.6765 2.23147 14.7348 2.27239C14.8829 2.37624 14.8847 2.39844 14.8847 4.10394C14.8847 5.48921 14.8789 5.70429 14.8385 5.78936C14.7685 5.93715 14.6487 5.97939 14.2998 5.97939C14.136 5.97939 13.978 5.99224 13.9487 6.00796C13.9193 6.02369 13.7138 6.24478 13.4919 6.49932C13.27 6.75386 13.0726 6.9795 13.0533 7.0008C13.0251 7.03192 12.9882 6.99889 12.8641 6.83136C12.7794 6.71689 12.686 6.61038 12.6567 6.59466C12.5504 6.53772 12.4003 6.56168 12.2997 6.65168C12.2192 6.72373 12.2041 6.75741 12.2048 6.86436C12.2055 6.97909 12.2344 7.03037 12.5028 7.39174C12.9765 8.0298 12.984 8.02854 13.7147 7.19036L14.2255 6.60437L14.5185 6.58993C14.7582 6.57817 14.8388 6.56163 14.9611 6.49911C15.1804 6.38711 15.2733 6.2977 15.3852 6.09089L15.4854 5.90605V4.10197V2.29788L15.4156 2.14329C15.3294 1.95232 15.0859 1.72251 14.8931 1.65009C14.7749 1.6057 14.6381 1.59599 14.0205 1.58831C13.4408 1.58106 13.2689 1.58772 13.1966 1.62016ZM7.72283 8.1814C7.49173 8.21693 7.37847 8.25494 7.14942 8.3739C6.39111 8.76768 5.99544 9.59463 6.16865 10.4236C6.31177 11.1084 6.88577 11.7006 7.56032 11.8593C7.66506 11.884 7.86282 11.9041 7.99979 11.9041C8.5243 11.9041 8.93254 11.735 9.30599 11.3629C9.70518 10.9651 9.89851 10.4729 9.86497 9.93958C9.8214 9.24707 9.44249 8.66985 8.82765 8.35926C8.5025 8.19501 8.07836 8.12672 7.72283 8.1814ZM8.35335 8.84272C8.57672 8.90899 8.73018 9.006 8.90596 9.19213C9.37221 9.68574 9.3587 10.4303 8.8747 10.916C8.38452 11.4078 7.61505 11.4078 7.12487 10.916C6.56264 10.3518 6.65054 9.45605 7.31293 8.99975C7.59138 8.80793 8.01865 8.74342 8.35335 8.84272ZM2.73759 9.13252C2.49779 9.18477 2.33689 9.27113 2.15038 9.44775C1.8848 9.69924 1.75937 9.98874 1.75937 10.3503C1.75937 10.7142 1.88462 11.0011 2.15548 11.2576C2.64847 11.7244 3.39202 11.7109 3.87713 11.2263C4.36839 10.7355 4.36839 9.96504 3.87713 9.47424C3.68666 9.28395 3.46904 9.16846 3.21154 9.12093C3.00077 9.08206 2.96535 9.08292 2.73759 9.13252ZM12.746 9.12882C12.6574 9.14813 12.519 9.1958 12.4384 9.23475C12.2383 9.33156 11.9703 9.6056 11.8778 9.80792C11.6506 10.3049 11.7444 10.8486 12.1224 11.2263C12.6075 11.7109 13.3511 11.7244 13.8441 11.2576C14.115 11.0011 14.2402 10.7142 14.2402 10.3503C14.2402 9.98874 14.1148 9.69924 13.8492 9.44775C13.6589 9.26755 13.5025 9.18515 13.2483 9.1312C13.0189 9.0825 12.9602 9.08224 12.746 9.12882ZM3.34751 9.83911C3.52087 9.96096 3.61828 10.1449 3.61828 10.3503C3.61828 10.8817 2.98847 11.1622 2.58724 10.8094C2.25137 10.5142 2.32716 10.0069 2.74085 9.78129C2.8034 9.74717 2.8854 9.73585 3.02524 9.74201C3.18831 9.7492 3.24313 9.76571 3.34751 9.83911ZM13.2672 9.7902C13.6724 9.99889 13.746 10.5161 13.4123 10.8094C13.011 11.1623 12.3794 10.8808 12.3821 10.3503C12.3835 10.0941 12.5213 9.87862 12.7462 9.78096C12.8914 9.71795 13.1353 9.72229 13.2672 9.7902ZM1.69005 12.2737C1.29638 12.3703 0.872882 12.7035 0.682622 13.0665C0.541261 13.3361 0.500508 13.5571 0.50001 14.0566C0.499658 14.4108 0.508682 14.5075 0.548351 14.5748C0.64266 14.7346 0.876368 14.7722 1.01796 14.6504L1.10017 14.5797L1.11591 14.0857C1.1302 13.6358 1.13832 13.5772 1.20676 13.4291C1.31355 13.1978 1.44246 13.0645 1.66594 12.9543L1.86048 12.8584L2.95985 12.8435C3.56452 12.8354 4.08066 12.8181 4.10682 12.8052C4.13299 12.7922 4.17769 12.7383 4.20617 12.6853C4.27241 12.5622 4.2471 12.4097 4.14435 12.313L4.06923 12.2424L2.96556 12.237C2.09088 12.2327 1.82626 12.2403 1.69005 12.2737ZM11.955 12.2484C11.8656 12.2811 11.7795 12.3866 11.7608 12.4864C11.7397 12.5991 11.8076 12.763 11.8927 12.8052C11.9189 12.8181 12.435 12.8354 13.0397 12.8435L14.1391 12.8584L14.3336 12.9543C14.5571 13.0645 14.686 13.1978 14.7928 13.4291C14.8613 13.5772 14.8694 13.6358 14.8837 14.0857L14.8994 14.5797L14.9816 14.6504C15.1232 14.7722 15.3569 14.7346 15.4512 14.5748C15.4907 14.5078 15.5 14.4108 15.5 14.0654C15.5 13.5635 15.472 13.4043 15.3315 13.1077C15.1357 12.6943 14.7001 12.354 14.2461 12.2599C14.0877 12.227 12.0413 12.2168 11.955 12.2484ZM5.90169 12.8723C5.2782 12.9668 4.77572 13.4222 4.61558 14.0377C4.56085 14.2481 4.55197 15.7011 4.60471 15.817C4.68551 15.9946 4.96041 16.0278 5.10195 15.8771C5.17223 15.8023 5.17261 15.7983 5.1872 14.9902L5.20185 14.1784L5.2833 14.0124C5.37275 13.83 5.52662 13.6747 5.72057 13.571L5.8464 13.5037H7.99979H10.1532L10.279 13.571C10.473 13.6747 10.6268 13.83 10.7163 14.0124L10.7977 14.1784L10.8124 14.9902C10.827 15.7983 10.8273 15.8023 10.8976 15.8771C11.0392 16.0278 11.3141 15.9946 11.3949 15.817C11.4476 15.7011 11.4387 14.2481 11.384 14.0377C11.2491 13.5193 10.8544 13.0961 10.3457 12.9246C10.1549 12.8602 10.1349 12.8596 8.10233 12.8546C6.97436 12.8518 5.98407 12.8598 5.90169 12.8723Z"
                    fill="#555555"
                  />
                </svg>
              </a>
            </li> */}



            {/* <li className="linedivider"></li>
            <li>
              <a href="#">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00066 3.32422V12.6576M2.33398 7.99089H11.6673"
                    stroke="#222222"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </li> */}
          </ul>
        </div>
        {this.state.opentasks && (
          <ActivityListDrawer
            {...this.props}
            // key={refresh}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            opentasks={this.state.opentasks}
            filterClose={this.filterActClose}
          />
        )}
        {this.state.opentimeline && (
          <TimelineListDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            opentimeline={this.state.opentimeline}
            filterClose={this.filterTimeClose}
          />
        )}
        {this.state.opennote && (
          <NoteListDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            opennote={this.state.opennote}
            filterClose={this.filterNoteClose}
          />
        )}
        {this.state.openemail && (
          <EmailListDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            openemail={this.state.openemail}
            filterClose={this.filterEmailClose}
          />
        )}
        {this.state.openforms && (
          // this.state.searchData.external_form_data
          <FormsDetailsDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            searchData={this.state.searchData}
            handlepagination={this.props.handlepagination}
            openformsdetail={this.state.openforms}
            filterValues={this.state.filterValues}
            handleSearchData={this.handleSearchData}
            handleSearchFilter={this.handleSearchFilter}
            filterClose={this.filterFormsClose}
          />

          // <FormsListDrawer
          //   {...this.props}
          //   // key={refresh}
          //   classesStyle={this.props.classesStyle}
          //   data={this.state.searchData}
          //   openforms={this.state.openforms}
          //   filterClose={this.filterFormsClose}
          // />
        )}
        {this.state.opencalls && (
          <CallsListDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            opencalls={this.state.opencalls}
            filterClose={this.filterCallsClose}
          />
        )}

        {this.state.opencommunication && (
          <CommunicationListDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            opencommunication={this.state.opencommunication}
            filterClose={this.filterCommunicationClose}
          />
        )}

        {this.state.openattachment && (
          <AttachmentListDrawer
            {...this.props}
            classesStyle={this.props.classesStyle}
            data={this.state.searchData}
            openattachment={this.state.openattachment}
            filterClose={this.filterAttachmentClose}
          />
        )}
      </div>
    );
  }
}

export default RightSideNav;
